import { useNavigate } from "react-router-dom";
import { translation as t } from "../utils/translation";
interface HeaderProps {
  title: string;
  description: string;
  buttonTitle: string;
  buttonText: string;
  buttonLink: string;
}
const Header = (props: HeaderProps) => {
  const navigate = useNavigate();
  const movePage = () => {
    window.dataLayer.push({
      Category: "Mortgage Calculator",
      Action: "Click",
      Label:
        props.title == t.CALCULATE_MIXES_TITLE
          ? "מעבר למחשבון מורחב"
          : "למחשבון משכנתא",
      event: "auto_event",
    });
    navigate(`/${props.buttonLink}`);
  };
  return (
    <div id="header" className="flex-1 bg-blue mt-5 rounded-m text-white py-5">
      <div className="lg:flex container mx-auto justify-around">
        <div className="flex-4">
          <h1 className="xxl:text-[40px] xs:text-[24px] font-bold bg-blue xs:mr-[17px]">
            {props.title}
          </h1>
          <h2 className="xxl:text-[28px] xs:text-[16px] xs:mr-[17px] xs:ml-[27px] ">
            {props.description}
          </h2>
        </div>
        <div className="flex-1"></div>
        <div className="flex-1 xs:mr-[17px]  xs:ml-[27px] xxl:text-center py-3">
          <p className=" xs:text-[13px] xxl:text-[18px] xs:mb-[10px] ">
            {props.buttonTitle}
          </p>
          <button
            onClick={() => movePage()}
            className="bg-white xs:w-[191px] xxl:w-full xs:h-37 xxl:h-[51px] text-darkBlue xxl:text-[24px] xs:text-[16px] rounded-lg font-bold xs:w-[191px] xxl:w-[325px] border-1 border-darkBlue "
          >
            {props.buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};
export default Header;